import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import ButtonContainer from "./buttonContainer";
import BasicCustomTable from "../../../../component/basicTable/index";
import { serviceRows, serviceColumns } from "../../../../constants/userTable";
import CustomButton from "../../../../component/elements/CustomButton/CustomButton";
import CustomPopupForm from "../../../../component/customPopupModel";
import { buildServicesDetailsPayload } from "../../../../utils/buildUserPayload";
import { useSnackbar } from "../../../../component/SnackbarContext";
import axiosInstance from "../../../../configuration/request";
import { creatService, generateServicesData } from "../../../../utils/servicesConfig";

function ServicesOffered({
  nextHandler,
  previousHandler,
  mode,
  services = [],
  storeId,
  updatePayload,
}) {
  const showSnackbar = useSnackbar();
  const [open, setOpen] = useState(false);
  const [servicesData, setServicesData] = useState([]);
  const [serviceTableData, setServiceTableData] = useState([]);

  useEffect(() => {
    if (mode === "edit") {
         fetchServices();
    }else{
      if(services?.tableData?.length > 0 && services?.servicePayload?.length > 0){
        setServiceTableData(services.tableData)
        setServicesData(services.servicePayload)
      }
    }
 
  }, []);

  const fetchServices = () => {
    axiosInstance
      .get(`/customer/services-offered?storeId=${storeId}`)
      .then((res) => {
        const formattedUser = generateServicesData(res?.data);
        setServiceTableData(formattedUser);
      })
      .catch((err) => {
        showSnackbar("Something went wrong!", "error");
      });
  };

   const updateService = async (service) => {
    try {
      await creatService(service, storeId);
      fetchServices();
    } catch (error) {
      showSnackbar("Something went wrong!", "error");
    }
  };

  const handleAddServices = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (service) => {
    const isDuplicate = checkDuplicate(service);
    if (isDuplicate) {
      showSnackbar("Service with same parameteres already exists!", "error");
      return;
    }
    if (mode === "edit") {
      updateService(service);
    } else {
      setServiceTableData((prev) => [...prev, service]);
      let serviceData = buildServicesDetailsPayload(service);
      setServicesData((prev) => [...prev, serviceData]);
    }
    setOpen(false);
  };

  const checkDuplicate = (service) => {
    const duplicate = serviceTableData.some(
      (item) =>
        item.serviceType === service.serviceType &&
        item.category === service.category &&
        item.clothType === service.clothType &&
        item.unit === service.unit &&
        item.tailoringType === service.tailoringType &&
        item.price === service.price &&
        item.lbs === service.lbs
    );
    return duplicate;
  };

 

  const onNext = () => {
    const uniqueServices = deduplicateServices(servicesData);
    if (mode === "create") {
  
      updatePayload(uniqueServices);
    }
    nextHandler(serviceTableData, "service_details");
  };
   
 const deduplicateServices = (servicesArray) => {
  const groupedData = [];

  servicesArray.forEach((item) => {
    const existing = groupedData.find((g) => g.serviceType === item.serviceType);

    if (existing) {
      if (item.unitDetails) {
        existing.unitDetails = existing.unitDetails || [];
        const details = Array.isArray(item.unitDetails) ? item.unitDetails : [item.unitDetails];
        existing.unitDetails.push(...details);
      }
      if (item.poundDetails) {
        existing.poundDetails = existing.poundDetails || [];
        const details = Array.isArray(item.poundDetails) ? item.poundDetails : [item.poundDetails];
        existing.poundDetails.push(...details);
      }
    } else {
      const newGroup = { serviceType: item.serviceType };
      if (item.unitDetails) {
        newGroup.unitDetails = Array.isArray(item.unitDetails) ? [...item.unitDetails] : [item.unitDetails];
      }
      if (item.poundDetails) {
        newGroup.poundDetails = Array.isArray(item.poundDetails) ? [...item.poundDetails] : [item.poundDetails];
      }
      groupedData.push(newGroup);
    }
  });

  return groupedData;
};



  return (
    <Box>
      <Box className="shadow-card py-7 px-6 rounded-[16px]">
        <div className="flex justify-end mb-3 ">
          <CustomButton
            onClick={handleAddServices}
            customeClass="outlined-button w-[150px] h-[40px]"
          >
            Add Services
          </CustomButton>
        </div>

        <BasicCustomTable
          columns={serviceColumns}
          rows={serviceTableData}
          colorHeader={false}
          customClassHeader={"table-header-normal"}
          frontendPagination={true}
           pageLimit={10}
        />
      </Box>
      <ButtonContainer
        handleNext={onNext}
        handlePrevious={previousHandler}
        mode={mode}
      />
      <CustomPopupForm
        isOpen={open}
        handleClose={handleClose}
        dialogType={"service-offered"}
        onSubmit={handleSubmit}
      />
    </Box>
  );
}

export default ServicesOffered;
